import { FC } from 'react';
import ProjectsTable from './Parts/ProjectsTable';

const ProjectsDashboard: FC = () => <ProjectsTable />;

export default ProjectsDashboard;
